import React from "react";
import Close from "../Svg/Close";
import Search from "../Svg/Search";
import "./Search.scss";

interface SearchInputProps {
  searchValue: string;
  onSearchChange: any;
  placeholder: string;
  size?: any;
  inputTestId?: string;
}

const SearchInput: React.FC<SearchInputProps> = ({
  searchValue,
  placeholder,
  onSearchChange,
  size = 20,
  inputTestId,
}) => {
  return (
    <div className="flex py-[10px] px-[14px] items-center self-stretch gap-[12px] rounded-[8px] border-[1px] border-darkcolor-400 bg-darkcolor-700 shadow-custom-box-shadow">
      <div className="flex items-center justify-center">
        <Search size={size} />
      </div>
      <div className="flex-1">
        <input
          onChange={onSearchChange}
          name="filter"
          className="w-full border-0 p-0 shadow-none outline-none bg-transparent text-color-search-input"
          value={searchValue}
          placeholder={placeholder}
          autoComplete="off"
          data-testid={inputTestId}
        />
      </div>
      {searchValue && searchValue.length > 0 && (
        <div className="flex items-center justify-center ">
          <Close onClick={() => onSearchChange("")} />
        </div>
      )}
    </div>
  );
};

export default SearchInput;
